(function () {
  'use strict';

  var dataElement = document.querySelector('[data-mylar-collection-products]');
  if (!dataElement || window.MylarCollectionTheme) return;

  var products;
  try {
    products = JSON.parse(dataElement.textContent);
  } catch (error) {
    console.error('Unable to initialize Mylar collection filters.', error);
    return;
  }

  var groups = [
    { key: 'style', title: 'Style', options: [
      { value: 'stand-up', label: 'Stand-Up' },
      { value: 'flat-bag', label: 'Flat Bag' },
      { value: 'foil-bag', label: 'Foil Bag' }
    ]},
    { key: 'closure', title: 'Closure', options: [
      { value: 'ziplock', label: 'Ziplock' },
      { value: 'open-end', label: 'Open End' }
    ]},
    { key: 'color', title: 'Color', options: [
      { value: 'clear', label: 'Clear' },
      { value: 'silver', label: 'Silver' },
      { value: 'clear-silver', label: 'Clear / Silver' },
      { value: 'clear-black', label: 'Clear / Black' },
      { value: 'black', label: 'Black' },
      { value: 'green', label: 'Green' }
    ]},
    { key: 'thickness', title: 'Thickness', options: [
      { value: '5-mil', label: '5.0 Mil' },
      { value: '8-mil', label: '8.0 Mil' }
    ]},
    { key: 'pack-size', title: 'Pack Size', options: [
      { value: '50', label: '50' },
      { value: '100', label: '100' }
    ]}
  ];
  var queryPrefix = 'mylar_';
  // Exact product-to-filter mapping supplied in "Mylar Foil Bags .xlsx" and subsequent product lists.
  // Do not infer filter membership from product titles, types, tags, or variants.
  var metadataByHandle = {
    '1-2-gallon-mylar-bag-ziplock-5-0-mil-8-x-12-x-4-bundle-of-100': { style: [], closure: ['ziplock'], color: ['silver'], thickness: ['5-mil'], 'pack-size': ['100'] },
    '1-gallon-mylar-bag-open-end-5-0-mil-10-x-16-bundle-of-100': { style: ['flat-bag'], closure: ['open-end'], color: ['silver'], thickness: ['5-mil'], 'pack-size': ['100'] },
    '1-gallon-mylar-bag-ziplock-5-0-mil-10-x-14-x-4-bundle-of-100': { style: [], closure: ['ziplock'], color: ['silver'], thickness: ['5-mil'], 'pack-size': ['100'] },
    '1-gallon-mylar-bag-ziplock-8-0-mil-10-x-14-x-4-bundle-of-100': { style: [], closure: ['ziplock'], color: ['silver'], thickness: ['5-mil'], 'pack-size': ['100'] },
    '1-oz-stand-up-pouch-one-side-clear-5-0-mil-5-12-x-3-15-x-1-97-bundle-of-50': { style: ['stand-up'], closure: ['ziplock'], color: ['clear-silver'], thickness: ['5-mil'], 'pack-size': ['50'] },
    '1-quart-mylar-bag-open-end-5-0-mil-6-x-10-bundle-of-100': { style: ['flat-bag'], closure: ['open-end'], color: ['silver'], thickness: ['5-mil'], 'pack-size': ['100'] },
    '1-quart-mylar-bag-ziplock-5-0-mil-6-x-8-x-2-bundle-of-50': { style: [], closure: ['ziplock'], color: ['silver'], thickness: ['5-mil'], 'pack-size': ['50'] },
    '12-oz-stand-up-pouch-one-side-clear-5-0-mil-11-x-6-x-3-bundle-of-50': { style: ['stand-up'], closure: [], color: ['clear-silver'], thickness: ['5-mil'], 'pack-size': ['50'] },
    '2-gallon-mylar-bag-open-end-5-0-mil-14-x-20-bundle-of-50': { style: ['flat-bag'], closure: ['open-end'], color: ['silver'], thickness: ['5-mil'], 'pack-size': ['50'] },
    '2-gallon-mylar-bag-ziplock-5-0-mil-14-x-18-x-6-bundle-of-50': { style: [], closure: ['ziplock'], color: ['silver'], thickness: ['5-mil'], 'pack-size': ['50'] },
    '2-oz-stand-up-pouch-one-side-clear-5-0-mil-6-50-x-3-94-x-1-02-bundle-of-50': { style: ['stand-up'], closure: ['ziplock'], color: ['clear-silver'], thickness: ['5-mil'], 'pack-size': ['50'] },
    '2-oz-stand-up-pouch-transparent-5-0-mil-6-50-x-3-94-x-1-02-bundle-of-50': { style: ['stand-up'], closure: ['ziplock'], color: ['clear'], thickness: ['5-mil'], 'pack-size': ['50'] },
    '4-oz-stand-up-pouch-clear-front-black-back-5-0-mil-8-x-5-x-2-5-bundle-of-50': { style: ['stand-up'], closure: ['ziplock'], color: ['clear-black'], thickness: ['8-mil'], 'pack-size': ['50'] },
    '4-oz-stand-up-pouch-one-side-clear-5-0-mil-8-x-5-x-2-5-bundle-of-50': { style: ['stand-up'], closure: ['ziplock'], color: ['clear-silver'], thickness: ['5-mil'], 'pack-size': ['50'] },
    '5-gallon-mylar-bag-open-end-5-0-mil-19-x-29-bundle-of-50': { style: ['flat-bag'], closure: ['open-end'], color: ['silver'], thickness: ['5-mil'], 'pack-size': ['50'] },
    '8-oz-stand-up-pouch-one-side-clear-5-0-mil-9-37-x-5-91-x-2-6-bundle-of-50': { style: ['stand-up'], closure: ['ziplock'], color: ['clear-silver'], thickness: ['5-mil'], 'pack-size': ['50'] },
    'black-shiny-mylar-bag-ziplock-5-0-mil-3-x-4-bundle-of-50': { style: ['flat-bag'], closure: [], color: ['black'], thickness: ['5-mil'], 'pack-size': ['50'] },
    'green-mylar-foil-bag-20-32cm-x-25-40cm-8-inches-x-10-inches-bundle-of-100': { style: ['flat-bag', 'foil-bag'], closure: ['open-end'], color: ['green'], thickness: ['5-mil'], 'pack-size': ['100'] },
    'green-mylar-foil-bag-45-09cm-x-47-63cm-17-75-inches-x-18-75-inches-bundle-of-50': { style: ['flat-bag', 'foil-bag'], closure: ['open-end'], color: ['green'], thickness: ['5-mil'], 'pack-size': [] }
  };

  products.forEach(function (product) {
    if (!metadataByHandle[product.handle]) {
      metadataByHandle[product.handle] = { style: [], closure: [], color: [], thickness: [], 'pack-size': [] };
    }
  });

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function buildForm() {
    var form = document.createElement('form');
    form.className = 'mylar-filter-form';
    form.setAttribute('data-mylar-filter-form', '');
    form.setAttribute('aria-label', 'Mylar product filters');
    form.innerHTML = groups.map(function (group) {
      var options = group.options.map(function (option) {
        return '<li class="tag mylar-filter__option">' +
          '<label class="tag__checkbox-wrapper text-label">' +
            '<input class="tag__input mylar-filter__input" type="checkbox" data-mylar-filter ' +
              'data-group="' + escapeHtml(group.key) + '" value="' + escapeHtml(option.value) + '">' +
            '<span class="tag__checkbox" aria-hidden="true"></span>' +
            '<span class="tag__text">' + escapeHtml(option.label) + '</span>' +
          '</label>' +
        '</li>';
      }).join('');
      return '<fieldset class="mylar-filter__group">' +
        '<legend class="mylar-filter__title">' + escapeHtml(group.title) + '</legend>' +
        '<ul class="no-bullets tag-list tag-list--checkboxes mylar-filter__list">' + options + '</ul>' +
      '</fieldset>';
    }).join('') +
      '<div class="mylar-filter__actions">' +
        '<button type="button" class="mylar-filter__clear" data-mylar-filter-clear>Clear all</button>' +
      '</div>';
    return form;
  }

  function getState() {
    var params = new URLSearchParams(window.location.search);
    var state = {};
    groups.forEach(function (group) {
      var allowed = group.options.map(function (option) { return option.value; });
      state[group.key] = params.getAll(queryPrefix + group.key).filter(function (value) {
        return allowed.indexOf(value) !== -1;
      });
    });
    return state;
  }

  function activeCount(state) {
    return groups.reduce(function (count, group) {
      return count + state[group.key].length;
    }, 0);
  }

  function syncForms(state) {
    document.querySelectorAll('[data-mylar-filter-form]').forEach(function (form) {
      form.querySelectorAll('[data-mylar-filter]').forEach(function (input) {
        input.checked = state[input.dataset.group].indexOf(input.value) !== -1;
        var item = input.closest('.tag');
        if (item) item.classList.toggle('tag--active', input.checked);
      });
      var clearButton = form.querySelector('[data-mylar-filter-clear]');
      if (clearButton) clearButton.disabled = activeCount(state) === 0;
    });
  }

  function matches(metadata, state) {
    return groups.every(function (group) {
      var selected = state[group.key];
      if (!selected.length) return true;
      return selected.some(function (value) {
        return metadata[group.key].indexOf(value) !== -1;
      });
    });
  }

  function updateCount(root, count) {
    root.querySelectorAll('.collection-filter__item--count').forEach(function (element) {
      element.textContent = count + (count === 1 ? ' product' : ' products');
    });
  }

  function updateSelectedTags(root, state) {
    var list = root.querySelector('.collection-list--active-tags');
    if (!list) return;
    list.classList.add('mylar-filter__selected-list');
    list.classList.remove('small--hide');
    list.innerHTML = '';

    groups.forEach(function (group) {
      group.options.forEach(function (option) {
        if (state[group.key].indexOf(option.value) === -1) return;
        var item = document.createElement('li');
        item.className = 'mylar-filter__selected-item';
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'mylar-filter__chip';
        button.dataset.group = group.key;
        button.dataset.value = option.value;
        button.setAttribute('aria-label', 'Remove ' + group.title + ' filter: ' + option.label);
        var remove = document.createElement('span');
        remove.className = 'mylar-filter__chip-remove';
        remove.setAttribute('aria-hidden', 'true');
        remove.textContent = '×';
        var label = document.createElement('span');
        label.textContent = option.label;
        button.appendChild(remove);
        button.appendChild(label);
        item.appendChild(button);
        list.appendChild(item);
      });
    });
  }

  function updateButton(root, count) {
    root.querySelectorAll('.collection-filter__btn').forEach(function (button) {
      var badge = button.querySelector('.mylar-filter__badge');
      if (!badge && count) {
        badge = document.createElement('span');
        badge.className = 'mylar-filter__badge';
        badge.setAttribute('aria-hidden', 'true');
        button.appendChild(badge);
      }
      if (badge) {
        badge.textContent = count;
        badge.hidden = count === 0;
      }
    });
  }

  function applyFilters() {
    var root = document.getElementById('CollectionAjaxResult');
    if (!root) return;
    var state = getState();
    var visible = 0;
    var cards = root.querySelectorAll('#Huratips-Loop > .grid-product[data-product-handle]');
    cards.forEach(function (card) {
      var metadata = metadataByHandle[card.dataset.productHandle];
      var show = !metadata || matches(metadata, state);
      card.classList.toggle('mylar-filtered-out', !show);
      card.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) visible += 1;
    });

    var grid = root.querySelector('#Huratips-Loop');
    var empty = root.querySelector('[data-mylar-empty-state]');
    if (grid && !empty) {
      empty = document.createElement('p');
      empty.className = 'mylar-filter__empty index-section';
      empty.setAttribute('data-mylar-empty-state', '');
      empty.textContent = 'No products match these filters.';
      grid.insertAdjacentElement('afterend', empty);
    }
    if (empty) empty.hidden = visible !== 0;
    syncForms(state);
    updateCount(root, visible);
    updateSelectedTags(root, state);
    updateButton(root, activeCount(state));
  }

  function updateUrl(form) {
    var params = new URLSearchParams(window.location.search);
    groups.forEach(function (group) {
      var name = queryPrefix + group.key;
      params.delete(name);
      form.querySelectorAll('[data-group="' + group.key + '"]:checked').forEach(function (input) {
        params.append(name, input.value);
      });
    });
    params.delete('page');
    var query = params.toString();
    window.history.pushState({}, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
    applyFilters();
  }

  function install() {
    var root = document.getElementById('CollectionAjaxResult');
    if (!root) return;
    root.classList.add('mylar-collection-theme');
    root.querySelectorAll('.filter-wrapper').forEach(function (wrapper) {
      var defaultForm = wrapper.querySelector('.filter-form');
      if (defaultForm) defaultForm.replaceWith(buildForm());
    });
    applyFilters();
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-mylar-filter]')) return;
    var form = event.target.closest('[data-mylar-filter-form]');
    if (form) updateUrl(form);
  });

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('.mylar-filter__chip');
    if (chip) {
      var filterForm = document.querySelector('[data-mylar-filter-form]');
      if (!filterForm) return;
      filterForm.querySelectorAll('[data-mylar-filter]').forEach(function (input) {
        if (input.dataset.group === chip.dataset.group && input.value === chip.dataset.value) {
          input.checked = false;
        }
      });
      updateUrl(filterForm);
      return;
    }

    var button = event.target.closest('[data-mylar-filter-clear]');
    if (!button) return;
    var form = button.closest('[data-mylar-filter-form]');
    if (!form) return;
    form.querySelectorAll('[data-mylar-filter]').forEach(function (input) { input.checked = false; });
    updateUrl(form);
  });

  window.addEventListener('popstate', applyFilters);
  document.addEventListener('collection:reloaded', install);
  document.addEventListener('shopify:section:load', install);
  window.MylarCollectionTheme = { install: install, apply: applyFilters };
  install();
})();
